import { rem } from 'polished'
import styled from 'styled-components'

import { mediaQueryUp } from 'components/utils/breakpoint'

export const MarginContainer = styled.div`
  padding-left: ${rem(20)};
  padding-right: ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding-left: ${rem(40)};
    padding-right: ${rem(40)};
  }

  &:empty {
    display: none;
  }
`
